let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("YzYU7")).then(() => parcelRequire('jcyQJ'));